import type { VoiceAssistantOpenFormInterface } from '@zaoblako/shared/modules/ai/dtos/voice-assistant/voice-assistant-open-form.dto';
import type { VoiceAssistantFormEnum } from '@zaoblako/shared/modules/ai/enums/voice-assistant-form.enum';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiVoiceAssistantService {
  private readonly baseUrl = '/ai/voice-assistant';

  public constructor(
    private readonly http: HttpClient
  ) {}

  /**
   * Transcript received file and detect form to open
   *
   * @param file MP3 file to transcript
   *
   * @returns Detected form type or `null` if form not detected
   */
  public openForm(file: File): Observable<VoiceAssistantFormEnum> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http
      .post<VoiceAssistantOpenFormInterface>(`${this.baseUrl}/open-form`, formData)
      .pipe(map(({ form }) => form));
  }
}
